const OPERATORS = new Set(['AND', 'OR', 'NOT'])

// Préfixe de facette devant une phrase ou un groupe (`title:(`, `news:"`), phrase, parenthèse, ou mot nu (éventuellement `facette:valeur`).
const TOKEN_RE = /[a-zA-Z]+:(?=["(])|"([^"]*)"|[()]|[^\s()"]+/g

// Garde les valeurs (mots nus, phrases, valeurs de facette), retire noms de facette, opérateurs, IDs opaques et termes exclus par NOT ; un faux positif n'a aucun coût visuel pour le surligneur.
export function extractSearchTerms(query: string | undefined | null): string[] {
  if (!query) return []
  const terms = new Set<string>()
  let depth = 0
  let notPending = false
  // Profondeur à laquelle a commencé un groupe exclu par NOT.
  let excludedFrom: number | null = null

  for (const [token, phrase] of query.matchAll(TOKEN_RE)) {
    if (token === '(') {
      if (notPending && excludedFrom === null) excludedFrom = depth
      notPending = false
      depth++
      continue
    }
    if (token === ')') {
      depth--
      if (excludedFrom !== null && depth <= excludedFrom) excludedFrom = null
      continue
    }
    if (token.endsWith(':')) continue
    if (phrase === undefined && OPERATORS.has(token.toUpperCase())) {
      if (token.toUpperCase() === 'NOT') notPending = true
      continue
    }
    if (excludedFrom !== null || notPending) {
      notPending = false
      continue
    }
    if (phrase !== undefined) {
      addPhrase(terms, phrase)
      continue
    }
    const value = token.replace(/^[a-zA-Z]+:/, '')
    // Deux-points chaînés ("event:afpevent:xxx") = id opaque, on ignore.
    if (value !== token && value.includes(':')) continue
    addBareToken(terms, value)
  }

  return [...terms]
}

function addBareToken(terms: Set<string>, token: string): void {
  // Retire la ponctuation résiduelle mais conserve accents, chiffres et traits d'union.
  const cleaned = token.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '')
  if (cleaned.length < 2) return
  terms.add(cleaned)
}

function addPhrase(terms: Set<string>, value: string): void {
  const trimmed = value.trim()
  if (trimmed.length < 2) return
  terms.add(trimmed)
}
